/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    CodeAndLabelWithIndent,
    CodeAndLabelWithIndentFromJSON,
    CodeAndLabelWithIndentFromJSONTyped,
    CodeAndLabelWithIndentToJSON,
    GlobalFilterAggregatorProviderMap,
    GlobalFilterAggregatorProviderMapFromJSON,
    GlobalFilterAggregatorProviderMapFromJSONTyped,
    GlobalFilterAggregatorProviderMapToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface GlobalFilterRuleFormConfiguration
 */
export interface GlobalFilterRuleFormConfiguration {
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof GlobalFilterRuleFormConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof GlobalFilterRuleFormConfiguration
     */
    readonly distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GlobalFilterRuleFormConfiguration
     */
    readonly relevances?: Array<number> | null;
    /**
     * 
     * @type {Array<CodeAndLabelWithIndent>}
     * @memberof GlobalFilterRuleFormConfiguration
     */
    readonly regions?: Array<CodeAndLabelWithIndent> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof GlobalFilterRuleFormConfiguration
     */
    readonly agencyGroups?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof GlobalFilterRuleFormConfiguration
     */
    readonly salesJourneys?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof GlobalFilterRuleFormConfiguration
     */
    fareTypes?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof GlobalFilterRuleFormConfiguration
     */
    providers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<GlobalFilterAggregatorProviderMap>}
     * @memberof GlobalFilterRuleFormConfiguration
     */
    readonly aggregatorProviderMaps?: Array<GlobalFilterAggregatorProviderMap> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof GlobalFilterRuleFormConfiguration
     */
    mixAndMatchProviders?: Array<GuidIdAndLabel> | null;
}

export function GlobalFilterRuleFormConfigurationFromJSON(json: any): GlobalFilterRuleFormConfiguration {
    return GlobalFilterRuleFormConfigurationFromJSONTyped(json, false);
}

export function GlobalFilterRuleFormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalFilterRuleFormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'relevances': !exists(json, 'relevances') ? undefined : json['relevances'],
        'regions': !exists(json, 'regions') ? undefined : (json['regions'] === null ? null : (json['regions'] as Array<any>).map(CodeAndLabelWithIndentFromJSON)),
        'agencyGroups': !exists(json, 'agencyGroups') ? undefined : (json['agencyGroups'] === null ? null : (json['agencyGroups'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'salesJourneys': !exists(json, 'salesJourneys') ? undefined : (json['salesJourneys'] === null ? null : (json['salesJourneys'] as Array<any>).map(CodeAndLabelFromJSON)),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(CodeAndLabelFromJSON)),
        'providers': !exists(json, 'providers') ? undefined : (json['providers'] === null ? null : (json['providers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'aggregatorProviderMaps': !exists(json, 'aggregatorProviderMaps') ? undefined : (json['aggregatorProviderMaps'] === null ? null : (json['aggregatorProviderMaps'] as Array<any>).map(GlobalFilterAggregatorProviderMapFromJSON)),
        'mixAndMatchProviders': !exists(json, 'mixAndMatchProviders') ? undefined : (json['mixAndMatchProviders'] === null ? null : (json['mixAndMatchProviders'] as Array<any>).map(GuidIdAndLabelFromJSON)),
    };
}

export function GlobalFilterRuleFormConfigurationToJSON(value?: GlobalFilterRuleFormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fareTypes': value.fareTypes === undefined ? undefined : (value.fareTypes === null ? null : (value.fareTypes as Array<any>).map(CodeAndLabelToJSON)),
        'providers': value.providers === undefined ? undefined : (value.providers === null ? null : (value.providers as Array<any>).map(GuidIdAndLabelToJSON)),
        'mixAndMatchProviders': value.mixAndMatchProviders === undefined ? undefined : (value.mixAndMatchProviders === null ? null : (value.mixAndMatchProviders as Array<any>).map(GuidIdAndLabelToJSON)),
    };
}


